// @flow

import React from "react";
import styles from "./loader.scss";

const loaderImgUrl = require("../../../assets/images/loader.gif");

type Props = {
  message?: string
};

const Loader = (props: Props) => (
  <div className={` ${styles.loaderIcnWrapper} l-row a-center j-center `}>
    <div className={styles.loaderImg}>
      <img
        className={`${styles.loaderIcn}`}
        src={loaderImgUrl}
        alt="Loading..."
      />
    </div>
    <div className={styles.loadingMsg}>{props.message}</div>
  </div>
);

Loader.defaultProps = {
  message: "Loading..."
};

export default Loader;



// WEBPACK FOOTER //
// ./app/components/commons/loader/loader.js